/**
 * Query-key constants shared across hook modules.
 *
 * These live here rather than in their owning hook files because
 * use-meal-plans and use-grocery-lists both need to reach into the other's
 * cache -- importing directly would make the two modules circular.
 */
export const MEAL_PLANS_QUERY_KEY = "meal-plans";
export const GROCERY_LISTS_QUERY_KEY = "grocery-lists";
export const RETAILERS_QUERY_KEY = "retailers";
